import { Row } from 'react-table';
import { EmployersResponse } from 'services/requests';
import Table from 'components/Table';
import TableFooter from 'components/Table/TableFooter';
import { columns, EmployerTableSign, MapData } from '../../Employers.columns';

type Props = {
  employersData: EmployersResponse | undefined;
  items: MapData | undefined;
  onClick: (row: Row<EmployerTableSign>) => void;
};

const RenderTable = ({ employersData, items, onClick }: Props): JSX.Element | null => {
  if (!employersData?.context || !items || (items && items?.length === 0)) return null;

  return (
    <Table<EmployerTableSign> columns={columns} data={items} onRowClick={onClick}>
      <TableFooter
        pages={employersData.context.pages}
        totalRows={employersData.context.totalRows}
      />
    </Table>
  );
};

export default RenderTable;
